import { useParams } from "react-router-dom";
import { useTrainingSession } from "@chess/shared";
import { TrainingPlayPage } from "@/pages/TrainingPlayPage";
import { ChoiceDrillPlay } from "@/pages/ChoiceDrillPlay";
import { SwipeDrillPlay } from "@/pages/SwipeDrillPlay";

/**
 * Route entry for /app/train/:sessionId. Fetches the session and renders the
 * play UI matching its drill mode — the classic find-the-move board
 * (TrainingPlayPage) or the fast multiple-choice flow (ChoiceDrillPlay). Each
 * child owns its own hooks; this dispatcher only branches on `drill_mode`, so
 * there's no conditional-hooks hazard. The session query is cached, so the
 * child re-reading it is a cache hit, not a second fetch.
 */
export function TrainDispatch() {
  const params = useParams<{ sessionId: string }>();
  const { data: session } = useTrainingSession(params.sessionId ?? null);

  // Once loaded, route a choice session to its dedicated UI. For everything
  // else — including the loading and error states — defer to the move page,
  // which already renders those states. The session query is cached, so the
  // move page re-reading it is a cache hit, not a second fetch.
  if (session?.drill_mode === "choice") {
    return <ChoiceDrillPlay session={session} />;
  }
  if (session?.drill_mode === "swipe") {
    return <SwipeDrillPlay session={session} />;
  }
  return <TrainingPlayPage />;
}
